import { formatNumber } from '../../../index.js';
import { TribunalCaseType } from '../../cases/types.js';
export var GLTribunalJobType;
(function (GLTribunalJobType) {
    GLTribunalJobType["CreateStaevning"] = "CREATE_STAEVNING";
    GLTribunalJobType["ResendStaevning"] = "RESEND_STAEVNING";
    GLTribunalJobType["RegisterVerdict"] = "REGISTER_VERDICT";
    GLTribunalJobType["CreateFogedbegaering"] = "CREATE_FOGEDBEGAERING";
    GLTribunalJobType["ResendFogedbegaering"] = "RESEND_FOGEDBEGAERING";
    GLTribunalJobType["RegisterInsolvens"] = "REGISTER_INSOLVENS";
    GLTribunalJobType["GLCreateBetalingspaakrav"] = "GL_CREATE_BETALINGSPAAKRAV";
    GLTribunalJobType["GLResendBetalingspaakrav"] = "GL_RESEND_BETALINGSPAAKRAV";
})(GLTribunalJobType || (GLTribunalJobType = {}));
export const tribunalGLJobReferenceCaseMap = {
    [GLTribunalJobType.CreateStaevning]: [TribunalCaseType.GLStaevning],
    [GLTribunalJobType.ResendStaevning]: [TribunalCaseType.GLStaevning],
    [GLTribunalJobType.RegisterVerdict]: [TribunalCaseType.GLStaevning],
    [GLTribunalJobType.CreateFogedbegaering]: [TribunalCaseType.GLFogedBegaering],
    [GLTribunalJobType.ResendFogedbegaering]: [TribunalCaseType.GLFogedBegaering],
    [GLTribunalJobType.RegisterInsolvens]: [TribunalCaseType.GLFogedBegaering],
    [GLTribunalJobType.GLCreateBetalingspaakrav]: [
        TribunalCaseType.GLBetalingspaakrav,
    ],
    [GLTribunalJobType.GLResendBetalingspaakrav]: [
        TribunalCaseType.GLBetalingspaakrav,
    ],
};
export const toPDFData = (staevningData) => {
    return {
        ...staevningData,
        courtFee: formatNumber(staevningData.courtFee),
        interests: formatNumber(staevningData.interests),
        totalAmount: formatNumber(staevningData.totalAmount),
    };
};
export const defaultGLStaevningSagsfremstilling = `
<p>Beløbet skyldes for:</p>
<br>
{{{caseVoucherTables.principalWithReferenceCaseVouchers}}}
<br>
<p>Da sagsøgte trods påkrav ikke har betalt beløbet, har nærværende sagsanlæg været nødvendig. Det forventes ikke, at sagsøgte har indsigelser mod kravet eller vil gøre modkrav gældende.</p>
<br>
<p>Herudover er der indbetalt kr. {{formattedFields.financials.depositedToCreditor}} direkte til kreditor samt kr. {{formattedFields.financials.depositedToCollector}} til undertegnede, efter sagen er overgivet til inkasso.</p>
<br>
<p>I rubrik A er der opgjort allerede påløbne fra de enkelte fakturaer i henhold til rentelovens § 3, stk. 2 og der søges herefter renter fra stævningens indlevering, jf. rentelovens § 3, stk. 4.</p>
`;
export const defaultGLFogedBegaeringSagsfremstilling = `<p><strong>Fogedbegæring</strong></p>
<p>{{debtor.name}}&nbsp;</p>
<p>{{debtorAddressFormatted}}&nbsp;</p>
<p>{{debtor.phone.number}}</p>
<p>E-mail: {{debtor.email}}</p>
<p>har ikke overholdt sine forpligtelser overfor min klient</p>
<p>{{case.creditor.name}}</p>
<p>{{case.creditor.address.address}}&nbsp;</p>
<p>CVR nr. {{creditorCentralRegisterId}}&nbsp;</p>
<p>v/ advokat Iris Ohms Jørgensen</p>
<p>v/ advokatfuldmægtig Christian Vollstedt</p>
<p>hvorfor debitor bedes tilsagt til fogedretten i medfør af retsplejelovens § 604.</p>
<p>Jeg vedlægger sagens fundament og fordringen opgøres således:</p>
<p>{{{debt.overview}}}</p>
<p>samt yderligere renter og omkostninger ved fogedforretningens foretagelse.</p>
<p>Skyldneren bedes indkaldt til fogedretsmøde og fogedretten anmodes om at foretage udlæg i debitors effekter, særligt i fast ejendom, løsøre, skibe, bank- og sparekassebeholdninger, værdipapirer, arbejds- og andre tilgodehavender.</p>
<p>Fogedretten er bemyndiget til at indgå afdragsordninger med skyldneren, såfremt sådan ordning findes rimelig og fornuftig. Også i tilfælde heraf bedes der foretaget udlæg til sikkerhed.</p>
<p>Min klients godkendelse af enhver afdragsordning forbeholdes.</p>
<p>Ejer skyldneren ikke udlægsegnede genstande og kan gælden ikke afvikles indenfor overskuelig tid, ønskes sagen tilbagesendt med bemærkning herom.</p>
<p>Såfremt skyldner tilbyder en afdragsordning, bedes ordningen straks iværksat, således at skyldner indbetaler de tilbudte afdrag til mit kontors konto i GrønlandsBANKEN A/S på konto:</p>
<p>{{payment.id}}&nbsp;</p>
<p>eller ved fast overførsel til kontonummer {{collector.registrationNumber}}-{{collector.accountNumber}} med reference til sagsnummer {{journalNumber}}.&nbsp;</p>
<p>Kopi af kvittering for overførsel af retsafgift kr. 300,00 til konto i GrønlandsBANKEN A/S konto nr. {{court.registrationnumber}}-{{court.accountnumber}} vedlægges.</p>
<p></p>
<p>Nuuk, den {{date}}&nbsp;</p>
<p></p>
<p>Christian Vollstedt</p>
`;
//# sourceMappingURL=greenland.js.map